export default "/images/1652b8c95510d6c5681c15ba298cf695.avif";